import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/AiIntegrationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/IndustriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/LazySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Metrics.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/ProjectShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/SeoBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/Technologies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/why-dev48/WhyDev48.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/WorkSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
